import { TextField } from "@mui/material";
import React, { useState } from "react";
import Swal from "sweetalert2";
import { ValidardocumentoSC } from "../../../Dashboard/Clientes/CapturasDashClientes/DocumentadionSC/SCDocumentoValidar";
import request from "../../../../Helpers/API";
import { ValOnlyTextWithSpace } from "../../../../Validators/ValOnlyTextWithSpace";


export const ModalDocumentacionReestructuracion = ({
    folio,
    documento,
    iddocumento,
    loader,
    setLoader,
    setdocumento,
    setdocumentos,
    cargar = false,
}) => {
    const [state, setState] = useState({
        documento: "",
        vencimiento: "",
        comentarios: "",
        extension: "",
        bdocumento: "",
        bvencimiento: "",
        bcomentarios: "",
    });

  



    const GetFile = ({ target }) => {
        if (
            target.files === undefined ||
            target.files === null ||
            target.files.length === 0
        )
            return;

        const file = target.files[0].name.split(".");
        if (file.length > 2) {
            Swal.fire("Clientes", "Archivo invalido", "error");
            return;
        }

        if (file[1] !== "jpg" && file[1] !== "jepg" && file[1] !== "pdf" && file[1] !== "PDF") {
            Swal.fire("Clientes", "Archivo con formato no valido", "error");
            target.value = "";
            return;
        }
        var fReader = new FileReader();
        fReader.readAsDataURL(target.files[0]);
        fReader.onloadend = function (event) {
            setState({
                ...state,
                documento: event.target.result,
                extension: file[1],
            });
        };
    };
    const onGuardar = () => {
        setLoader({ ...loader, mostrar: true });

        var valido = ValidardocumentoSC(state);
        if (valido === false) {
            setLoader({ ...loader, mostrar: false });
            return;
        }
        valido.folio = folio;
        valido.iddocumento = Number(iddocumento);

        request
            .post("SolicitudCreditoDocumentacion/GuardarDocumentoReestructuracion", valido)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                await Swal.fire(
                    "DOCUMENTACION SOLICITUD DE CREDITO",
                    "Documento cargado con exito",
                    "success"
                );

                if (cargar === undefined || cargar === null || cargar === false) {
                    setdocumentos(result.documentacion);
                   
                } else {
                    setdocumentos();
                }
                closedModal();
            })
            .catch(async (error) => {
                await Swal.fire(
                    "DOCUMENTACION SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
                setLoader({ ...loader, mostrar: false });
            });

        // setLoader({ ...loader, mostrar: false });
    };
    const closedModal = () => {
        var modal = document.getElementById("modal-documentos");
        modal.style.display = "none";
        // document.getElementById("clientes-documento").value = "";
        setdocumento({
            documento: "",
            iddocumento: "",
        });
        setState({
            documento: "",
            vencimiento: "",
            comentarios: "",
            estatus: true,
        });
    };
    const onChange = (prop, value, sbool, smensaje) => {
        setState({
            ...state,
            [prop]: value,
            ["b" + prop]: false,
            ["m" + prop]: "",
        });
    };

    return (
        <div id="modal-documentos" class="modal">
            <div class="modal-content-documentos">
                <div class="modal-header-documentos">
                    <span class="close" onClick={closedModal}>
                        &times;
                    </span>
                    <div className="encabezado">
                        <div className="titulo">{documento}</div>
                        <div className="border-green"></div>
                    </div>
                </div>
                <div class="modal-body-documentos">
                    <div className="div-documentos-text">
                        <TextField
                            id="clientes-documento"
                            type="file"
                            className="w-80"
                            onChange={GetFile}
                            sx={{ mb: 2, width: 100 }}
                            error={state.bdocumento}
                        />
                        <TextField
                            id="date"
                            label="VENCIMIENTO"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            sx={{ mb: 2 }}
                            error={state.bvencimiento}
                            onChange={({ target }) =>
                                setState({ ...state, vencimiento: target.value })
                            }
                            value={state.vencimiento}
                        />
                    </div>
                    <TextField
                        id="date"
                        fullWidth
                        label="COMENTARIOS"
                        type="Text"
                        multiline
                        error={state.bcomentarios}
                        maxRows={3}
                        rows={3}
                        InputLabelProps={{ shrink: true }}
                        onChange={({ target }) =>
                            ValOnlyTextWithSpace(
                                "comentarios",
                                target.value,
                                onChange,
                                true,
                                500
                            )
                        }
                        value={state.comentarios}
                    />
                </div>
                <div className="footer-guardar-domicilio">
                    <div className="button-guardar" onClick={onGuardar}>
                        GUARDAR
                    </div>
                </div>
            </div>
        </div>
    );
};
